import LegalLayout, { H2, P, UL, B } from "./LegalLayout";

export default function Confidentialitate() {
    return (
        <LegalLayout title="Politica de confidențialitate" updated="iunie 2026">
            <P>
                Această politică descrie modul în care <B>OPTIM SAFE</B> (operat de <B>Ilaș Gabriela Elena</B>,
                asistent în brokeraj pentru SAFETY BROKER DE ASIGURARE S.A.) prelucrează datele dumneavoastră cu
                caracter personal atunci când utilizați site-ul <B>www.optimsafe.ro</B>, în conformitate cu
                Regulamentul (UE) 2016/679 („GDPR") și legislația națională aplicabilă.
            </P>

            <H2>1. Ce date colectăm</H2>
            <UL
                items={[
                    <>Date transmise prin formularele de pe site: <B>nume, număr de telefon, adresă de e-mail, produsul de interes, preferința de contact și mesajul</B> dumneavoastră.</>,
                    <>Date colectate automat: adresă IP, tip de browser și dispozitiv, pagini vizitate (prin cookie-uri și tehnologii similare — vezi <a href="/politica-cookies" className="underline font-medium text-[#0d3d2e]">Politica Cookie</a>).</>,
                ]}
            />

            <H2>2. Scopul și temeiul prelucrării</H2>
            <UL
                items={[
                    <><B>Ofertare și contact</B> — pentru a vă contacta și a vă transmite oferte personalizate pentru produsele solicitate. Temei: demersuri precontractuale la cererea dumneavoastră (art. 6 alin. 1 lit. b GDPR) și consimțământul exprimat prin trimiterea formularului (art. 6 alin. 1 lit. a GDPR).</>,
                    <><B>Îmbunătățirea site-ului</B> — statistici anonime de trafic. Temei: interes legitim (art. 6 alin. 1 lit. f GDPR).</>,
                    <><B>Îndeplinirea obligațiilor legale</B> — arhivare, raportare către autorități, dacă este cazul (art. 6 alin. 1 lit. c GDPR).</>,
                ]}
            />

            <H2>3. Cui transmitem datele</H2>
            <UL
                items={[
                    <><B>SAFETY BROKER DE ASIGURARE S.A.</B> și societăților de asigurare partenere — exclusiv pentru obținerea cotațiilor și emiterea polițelor solicitate.</>,
                    <><B>Furnizori tehnici</B> — servicii de găzduire web, serviciul de transmitere e-mail (Resend) și instrumente de analiză a traficului, care acționează ca persoane împuternicite.</>,
                    "Autorităților publice, doar atunci când legea o impune.",
                ]}
            />
            <P>Datele dumneavoastră <B>nu sunt vândute</B> și nu sunt folosite în alte scopuri de marketing fără acordul dumneavoastră.</P>

            <H2>4. Durata stocării</H2>
            <P>
                Cererile de ofertă sunt păstrate maximum <B>3 ani</B> de la ultima interacțiune, cu excepția
                situațiilor în care legea impune un termen mai lung (de ex. documente aferente polițelor încheiate).
                Puteți solicita ștergerea datelor oricând, la adresa de mai jos.
            </P>

            <H2>5. Drepturile dumneavoastră</H2>
            <UL
                items={[
                    "Dreptul de acces la date și de a primi o copie a acestora;",
                    "Dreptul la rectificarea datelor inexacte;",
                    "Dreptul la ștergerea datelor („dreptul de a fi uitat”);",
                    "Dreptul la restricționarea prelucrării;",
                    "Dreptul la portabilitatea datelor;",
                    "Dreptul de opoziție la prelucrare;",
                    "Dreptul de a vă retrage consimțământul, oricând, fără a afecta legalitatea prelucrării anterioare;",
                    "Dreptul de a nu face obiectul unei decizii bazate exclusiv pe prelucrare automată.",
                ]}
            />
            <P>
                Pentru exercitarea acestor drepturi, scrieți-ne la <B>oferte@optimsafe.ro</B>. Vă vom răspunde în
                cel mult 30 de zile.
            </P>

            <H2>6. Plângeri</H2>
            <P>
                Dacă apreciați că prelucrarea datelor încalcă legislația, puteți depune o plângere la{" "}
                <B>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</B> —{" "}
                <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" className="underline">
                    www.dataprotection.ro
                </a>
                , B-dul G-ral Gheorghe Magheru nr. 28-30, sector 1, București.
            </P>

            <H2>7. Securitatea datelor</H2>
            <P>
                Aplicăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor: conexiune criptată
                (HTTPS), acces restricționat pe bază de autentificare la datele din formulare și stocare pe servere
                securizate.
            </P>

            <H2>8. Actualizări</H2>
            <P>
                Această politică poate fi actualizată periodic. Versiunea curentă este publicată permanent pe
                această pagină, împreună cu data ultimei actualizări.
            </P>
        </LegalLayout>
    );
}
